import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { AuthContext } from "./AuthContext";
import axios from "axios";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const UserContext = React.createContext();

const UserProvider = (props) => {
  const { isLoggedIn, signOut } = useContext(AuthContext);

  const queryClient = useQueryClient();
  const {
    data: user,
    isLoading: loadingUser,
    refetch,
    isError,
  } = useQuery(
    ["PROFILE"],
    () =>
      axios.get(`${process.env.REACT_APP_BASE_URL}/user`).then((response) => {
        return response.data;
      }),
    {
      retry: false,
      retryOnMount: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled: Boolean(isLoggedIn),
    }
  );

  useEffect(() => {
    if (isError) {
      queryClient.removeQueries(["PROFILE"]);
    }
  }, [isError]);

  useEffect(() => {
    if (isLoggedIn) {
      refetch();
    } else {
      signOut();
    }
  }, [isLoggedIn]);

  return (
    <UserContext.Provider
      value={{
        user: user,
        loadingUser,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserProvider;
